import { useState } from 'react';
import PageTabs from '../../components/common/PageTabs';
import CameraConfigTab from './CameraConfigTab';
import SettingsTab from './SettingsTab';

const TABS = [
  { key: 'cameras', label: 'Cameras' },
  { key: 'settings', label: 'Settings' },
];

export interface AttendanceConfigPageProps {
  /** Changes when the operator switches node (cloud); forces a refetch. */
  nodeKey?: string;
}

/**
 * The former Cameras and Settings tabs, merged into one Attendance Config page —
 * both are `attendance.config`-only surfaces, so they share a nav entry and split
 * into inner sub-tabs instead of two sidebar items.
 */
export default function AttendanceConfigPage({ nodeKey = '' }: AttendanceConfigPageProps) {
  const [tab, setTab] = useState('cameras');

  return (
    <div className="space-y-3">
      <PageTabs tabs={TABS} active={tab} onChange={setTab} />
      {tab === 'cameras' ? <CameraConfigTab nodeKey={nodeKey} /> : <SettingsTab nodeKey={nodeKey} />}
    </div>
  );
}
